export const getRequestId = (): string | undefined => {
  const root = document.getElementById('root');
  if (root) {
    const requestId = root.getAttribute('requestId');
    if (requestId) {
      return requestId;
    }
  }
  return undefined;
};